var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row product-item-wrapper row-no-gutters"},_vm._l((_vm.items),function(item){return _c('div',{key:item.text,staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4 product-item-outer"},[_c('product-item-img',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ca0a88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductItem.vue
// module id = null
// module chunks = 